import { CountResponse } from '@interfaces/common.interface';
import {
  CountEthnicitiesRequestParams,
  CreateEthnicityRequest,
  Ethnicity,
  GetEthnicitiesRequestParams,
  UpdateEthnicityRequest,
} from '@interfaces/ethnicities.interface';

import api from './';

export const {
  useCountEthnicitiesQuery,
  useGetManyEthnicitiesQuery,
  useCreateEthnicityMutation,
  useUpdateEthnicityMutation,
  useDeleteEthnicityMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    countEthnicities: build.query<CountResponse, CountEthnicitiesRequestParams>(
      {
        query: (params) => ({ url: 'ethnicities/count', params }),
        providesTags: ['ethnicities'],
      },
    ),
    getManyEthnicities: build.query<Ethnicity[], GetEthnicitiesRequestParams>({
      query: (params) => ({ url: 'ethnicities', params }),
      providesTags: ['ethnicities'],
    }),
    createEthnicity: build.mutation<Ethnicity, CreateEthnicityRequest>({
      query: (body) => ({
        url: 'ethnicities',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ethnicities'],
    }),
    updateEthnicity: build.mutation<Ethnicity, UpdateEthnicityRequest>({
      query: ({ id, body }) => ({
        url: `ethnicities/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['ethnicities'],
    }),
    deleteEthnicity: build.mutation<Ethnicity, string>({
      query: (id) => ({
        url: `ethnicities/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ethnicities'],
    }),
  }),
});
